/*
 * Pipeline Theme – Custom JS
 * Hover inmediato a imagen 2 en grid de colección
 * y retorno a imagen 1 al salir (UX tipo Bowen)
 */

console.log('Custom cargado ✅');

(function () {

  /**
   * Inicializa el comportamiento hover en productos del grid
   * Se ejecuta:
   * - al cargar la página
   * - cuando la colección se vuelve a renderizar (AJAX / filtros)
   */
  function initCollectionHover() {
    const items = document.querySelectorAll('product-grid-item');

    items.forEach(item => {
      // Evita inicializar dos veces el mismo item
      if (item.dataset.hoverInit) return;
      item.dataset.hoverInit = 'true';

      let lock = false;

      /**
       * HOVER → mostrar imagen 2 inmediatamente
       */
      item.addEventListener('mouseenter', () => {
        if (lock) return;

        // Pipeline renderiza cada imagen como:
        // <product-grid-item-image class="... is-active">
        const frames = item.querySelectorAll(
          'product-grid-item-image.product-grid-item__image-wrapper'
        );

        // Necesitamos mínimo 2 imágenes
        if (frames.length < 2) return;

        lock = true;

        // Desactivar todas
        frames.forEach(el => el.classList.remove('is-active'));

        // Activar la segunda imagen
        frames[1].classList.add('is-active');

        // Liberar rápido para no romper el loop interno del theme
        setTimeout(() => {
          lock = false;
        }, 100);
      });

      /**
       * LEAVE → volver a la imagen principal (imagen 1)
       */
      item.addEventListener('mouseleave', () => {
        const frames = item.querySelectorAll(
          'product-grid-item-image.product-grid-item__image-wrapper'
        );

        if (!frames.length) return;

        frames.forEach(el => el.classList.remove('is-active'));
        frames[0].classList.add('is-active'); // 👈 imagen principal

        lock = false;
      });
    });
  }

  /**
   * Ejecutar al cargar el DOM
   */
  document.addEventListener('DOMContentLoaded', () => {
    initCollectionHover();
  });

  /**
   * Ejecutar cuando Pipeline re-renderiza la colección
   * (filtros, paginación AJAX, etc.)
   */
  document.addEventListener('theme:collection:render', () => {
    initCollectionHover();
  });

})();
